export class DeliveryTrack {
  internal_track_number: string;
  external_track_number: string;
  service: string;
}
